import { useTranslation } from '@zurich/common/hooks';
import { Typography } from '@zurich/ui/atoms';
import { StepLayout } from '~/components/Steps/StepLayout';

export function Kilometers() {
  const { t } = useTranslation();

  return (
    <StepLayout
      stepName="kilometers"
      illustration="/images/vsga/kilometerstand.svg"
      alt={t('vsga:kilometers.title')}
      cameraButtonText={t('vsga:general.nextButtonPhoto')}
    >
      <Typography variant="body2 regular" color="darkBlue">
        {t('vsga:kilometers.body')}
      </Typography>
    </StepLayout>
  );
}
